const SLOWEST_PLAYBACK_SPEED = 0.5
const SLOW_PLAYBACK_SPEED = 0.75
const NORMAL_PLAYBACK_SPEED = 1
const FAST_PLAYBACK_SPEED = 1.25
const FASTER_PLAYBACK_SPEED = 1.5
const FASTEST_PLAYBACK_SPEED = 2

const VIDEO_PLAYBACK_SPEED_OPTIONS: readonly number[] = [
  SLOWEST_PLAYBACK_SPEED,
  SLOW_PLAYBACK_SPEED,
  NORMAL_PLAYBACK_SPEED,
  FAST_PLAYBACK_SPEED,
  FASTER_PLAYBACK_SPEED,
  FASTEST_PLAYBACK_SPEED,
]

export const getNextPlaybackSpeed = (currentSpeed: number): number => {
  const currentIndex = VIDEO_PLAYBACK_SPEED_OPTIONS.indexOf(currentSpeed)
  const nextIndex = (currentIndex + 1) % VIDEO_PLAYBACK_SPEED_OPTIONS.length
  return VIDEO_PLAYBACK_SPEED_OPTIONS[nextIndex]
}
